import { render, staticRenderFns } from "./InsertPassphrase.vue?vue&type=template&id=70d79c70&"
import script from "./InsertPassphrase.vue?vue&type=script&lang=js&"
export * from "./InsertPassphrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports